<template>
  <div v-if="hasContent" class="mb-20">
    <p class="sans border-t mt-8" v-for="block in blocks">
      <span class="uppercase text-sm tracking-wide text-sm pb-2 pt-2 block mb-4">{{ block.title }}</span>
      <span class="inline-block pt-2">
        <router-link class="p-3 text-sm rounded text-lg no-underline text-white text-data sans tracking-wide bg-grey-darkest mb-4" v-for="entry in block.entries" :key="entry.uri" :to="entry.uri">{{ entry.title }}   &rarr;</router-link>
      </span>
    </p>
  </div>
</template>
<script>
export default {
  name: 'related-content',
  props: ['related'],

  computed: {
    hasContent () {
      return (this.related)
    },

    blocks () {
      return this.related
    }

  }
}
</script>
